import * as Yup from "yup";
import { FORM_ERROR_MESSAGES } from "@shared/constants";
import { SensorDataSessionMarkerFormShape } from "@containers/SensorDataSession/interfaces";

export const createValidationSchema = Yup.object().shape({
  title: Yup.string().max(35, `Marker Title ${FORM_ERROR_MESSAGES.LONG}`).required(FORM_ERROR_MESSAGES.REQUIRED),
  color: Yup.string().required(FORM_ERROR_MESSAGES.REQUIRED),
});

export const getInitValues = (): SensorDataSessionMarkerFormShape => {
  return {
    title: "",
    color: "#009A7E",
  };
};
